interface ComparisonBarData {
  value: string;
  height: string;
}

interface ComparisonItem {
  percentage: string;
  title: string;
  description: string;
  withoutNoPing: ComparisonBarData;
  withNoPing: ComparisonBarData;
}

interface ComparisonStatsProps {
  title: string;
  description: string;
  items: ComparisonItem[];
  withNoPingLabel: string;
  withoutNoPingLabel: string;
  showBackground?: boolean;
  backgroundImage?: string;
}

function ComparisonStats({ title, description, items, withNoPingLabel, withoutNoPingLabel, showBackground = true, backgroundImage = '/assets/images/boost-fps/vector.png' }: ComparisonStatsProps) {
  const backgroundStyle = showBackground ? { backgroundImage: `url('${backgroundImage}')` } : {};

  return (
    <section className='flex w-full flex-col items-center justify-center gap-5 bg-contain bg-left-bottom bg-no-repeat px-5 xl:gap-20' style={backgroundStyle}>
      <div className='flex w-full max-w-[1400px] flex-col items-center justify-center'>
        <h3 className='mb-10 text-center text-6xl font-bold leading-10 text-white tablet:text-[3.125rem]'>{title}</h3>
        <p className='w-full max-w-[728px] text-center font-medium text-[#B3B3BE]'>{description}</p>

        <div className='mt-20 flex w-full max-w-screen-lg flex-col items-center justify-between xl:flex-row xl:gap-20'>
          {items.map((item, index) => (
            <div key={index} className='flex w-full flex-col items-center justify-center'>
              <p className='text-6xl font-bold text-white'>{item.percentage}</p>
              <p className='font-medium text-white'>{item.title}</p>
              <p className='!mt-4 h-28 max-w-[300px] text-center font-medium text-[#6C7784]'>{item.description}</p>

              <div className='mt-10 flex w-full max-w-[169px] items-end gap-4 xl:mt-14'>
                <div className='flex w-full flex-col items-center'>
                  <p className='h-[40px] w-full max-w-[110px] content-center text-center text-[14px] font-medium text-white'>{item.withoutNoPing.value}</p>
                  <div className='w-full max-w-[78px] rounded-sm bg-[#616C7B]' style={{ height: item.withoutNoPing.height }} />
                  <p className='h-12 w-full max-w-[110px] text-center font-medium text-[#6C7784]'>{withoutNoPingLabel}</p>
                </div>
                <div className='flex w-full flex-col items-center'>
                  <p className='h-[40px] w-full max-w-[110px] content-center text-center text-[14px] font-medium text-white'>{item.withNoPing.value}</p>
                  <div className='w-full max-w-[78px] rounded-sm bg-[#AEF55C]' style={{ height: item.withNoPing.height }} />
                  <p className='h-12 w-full max-w-[110px] text-center font-medium text-[#6C7784]'>{withNoPingLabel}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export { ComparisonStats };
export type { ComparisonBarData, ComparisonItem, ComparisonStatsProps };
